export enum ShipmentStatus {
  PACKAGED = 'Packaged',

  PENDING_PICKUP = 'Pending Carrier Pickup',

  PICKED_UP = 'Carrier Picked Up',

  IN_TRANSIT = 'In Transit',

  DELIVERED = 'Delivered',

  RETURNED = 'Returned',

  CANCELLED = 'Cancelled',
}
